import { useMantineTheme } from "@mantine/core";
import IconGem from "@common/components/icons/IconGem";

export const UpsellGem = () => {
  const theme = useMantineTheme();
  return <IconGem color={theme.colors.blue[2]} />;
};
